export const loadScript = (url: string) => {
  const head = document.querySelector('head');
  if (head) {
    return new Promise(function (resolve, reject) {
      const scriptEl = document.createElement('script');
      scriptEl.async = true;
      scriptEl.src = url;
      scriptEl.onload = resolve;
      scriptEl.onerror = reject;

      return head.appendChild(scriptEl);
    });
  } else {
    return Promise.reject();
  }
};
